import { render } from "./LotteryDraw.vue?vue&type=template&id=ba352716&scoped=true"
import script from "./LotteryDraw.vue?vue&type=script&lang=js"
export * from "./LotteryDraw.vue?vue&type=script&lang=js"

import "./LotteryDraw.vue?vue&type=style&index=0&id=ba352716&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba352716"]])

export default __exports__